import React,{useState} from 'react';
import PropTypes from 'prop-types';
const LoginModal = React.lazy(() => import('./loginModal'));

function ProfileInstitution(props) {
    
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => setIsOpen(!isOpen);
    // add tablet view
    const is_mobile = window.innerWidth < 768 || (
      window.innerWidth >= 768 &&
      window.innerWidth <= 1024 &&
      window.innerHeight >= 600
  ) || (
      // iPad Pro 
      window.innerWidth >= 1024 &&
      window.innerWidth <= 1366 &&
      window.innerHeight >= 768
  );

    const openLoginModal = () => {
        let tglogin = document.getElementById("tglogin");
        if (tglogin.classList.contains("in")) {
          tglogin.classList.toggle("in");
          setTimeout(() => {
            tglogin.style.display = "none";
          }, 100);
        } else {
          tglogin.style.display = "block";
          setTimeout(() => {
            tglogin.classList.toggle("in");
          }, 100);
        }
      };

    function copyText(textToCopy) {
        const tempInput = document.createElement('input');
        tempInput.value = textToCopy;
        document.body.appendChild(tempInput);
        tempInput.select();
        tempInput.setSelectionRange(0, 99999); 
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        alert('Access key copied to clipboard');
    }
    let access_token = btoa(JSON.stringify({...props.institution, 'exp': Date.now() + 365/2*24*60*60*1000}));
    return (<>
        <div>
            <div className="btn-group">
                <button type="button" id="myaccount-btn-inst" className="btn btn-insitution-access btn-block" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"  onClick={toggleOpen}><small>Access by {props.institution.name}</small></button>
                <ul id="myaccount-menu-inst" className={`dropdown-menu ${isOpen ? 'show' : ''}`} role="menu">
                {(is_mobile && props.institution && props.referral)
                         ? <li><a id="subscribeBtn"  rel="noreferrer" href="#" onClick={() => copyText(access_token)}  data-target="#instlogout"className="btn btn-info btn-block"><small>Copy access key</small></a></li>
                         : "" }
                    <li><a id="instlogout" href="#" title="Log out of institution access" onClick={props.handleLogout} data-target="#instlogout" className="btn btn-block"><small>Log out</small></a></li>
                </ul>
            </div>
        </div>
        <LoginModal />
        </>);
}

export default ProfileInstitution;

ProfileInstitution.propTypes = {
    institution: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    handleLoginClick: PropTypes.func.isRequired,
    handleLogout: PropTypes.func.isRequired,
  };